import { Box, Image, VisuallyHidden } from "@chakra-ui/react"
import { PaymentMethodConfig } from "@typings/visma"

type PaymentMethodProps = {
  method: PaymentMethodConfig
}

const getPaymentLogo = (method: PaymentMethodConfig): string => {
  switch (method.name) {
    case "Nordea":
      return "/images/nordea.svg"
    case "Osuuspankki":
      return "/images/op.svg"
    case "Aktia":
      return "/images/aktia.svg"
    case "Handelsbanken":
      return "/images/handelsbanken.svg"
    case "Säästöpankki":
      return "/images/saastopankki.svg"
    case "Danske Bank":
      return "/images/danskebank.svg"
    case "Ålandsbanken":
      return "/images/alandsbanken.svg"
    case "POP Pankki":
      return "/images/pop.svg"
    case "Visa":
      return "/images/visa.svg"
    case "Mastercard":
      return "/images/mastercard.svg"
    case "Oma Säästöpankki":
      return "/images/oma-saastopankki.svg"
    case "Mobilepay":
      return "/images/mobilepay.svg"
    case "Pivo":
      return "/images/pivo.png"
    case "Siirto":
      return "/images/siirto.png"
    case "Masterpass":
      return "/images/masterpass.png"
    default:
      return method.img
  }
}

const PaymentMethod = ({ method }: PaymentMethodProps): JSX.Element => {
  return (
    <Box as="span">
      <Image
        src={getPaymentLogo(method)}
        alt={method.name}
        w="100%"
        maxW="70%"
        maxH="90px"
        margin="0 auto"
        mb="1"
      />
      <VisuallyHidden>{method.name}</VisuallyHidden>
    </Box>
  )
}

export default PaymentMethod
